const ITEM_CFT_MAPPING = {
  "sofa 1 seater": 18,
  "sofa 2 seater": 35,
  "sofa 3 seater": 55,
  "dining table 4 seater": 35,
  "dining table 6 seater": 50,
  "center table": 10,
  "side table": 6,
  "tv unit": 20,
  "led tv 32 42 inch": 6,
  "led tv 43 55 inch": 8,
  "king size bed": 60,
  "queen size bed": 50,
  "single bed": 30,
  "mattress king": 18,
  "mattress queen": 15,
  "mattress single": 10,
  "single mattress": 10,
  "double mattress": 15,
  wardrobe: 45,
  "2 door wardrobe": 35,
  "3 door wardrobe": 50,
  "books shelf": 20,
  "study table": 18,
  "dressing table": 25,
  "bedside table": 6,
  refrigerator: 30,
  "washing machine": 18,
  dishwasher: 15,
  microwave: 4,
  "water purifier": 2,
  "ac 1 ton": 8,
  "ac 1 5 ton": 10,
  "office chair": 8,
  "office table": 20,
  "filing cabinet": 15,
  "workstation desk": 25,
  "conference table": 60,
  "desktop computer": 4,
  printer: 5,
  "ups inverter": 6,
  "carton box small": 3,
  "carton box medium": 5,
  "carton box large": 7,
  "music system": 6,
  cycle: 18,
  "double cot": 55,
  "home theatre": 4,
  mirrors: 4,
  "vcr vcd dvd": 2,
  pictures: 2,
  "kitchen vessel set": 8,
  pillow: 1,
  "puja metalware": 2,
  books: 3,
  "cooker 5kg": 2,
  "idly stainless steel maker": 2,
  mat: 2,
  "steel almirah": 40,
  "plastic chair": 4,
  "wooden chair": 6,
  "folding chair": 3,
  "stool": 2,
  "shoe rack": 10,
  "hanger stand": 6,
  "computer table": 18,
  "laptop": 2,
  "keyboard": 1,
  "cpu": 3,
  "gas cylinder": 6,
  "gas stove": 4,
  "kitchen rack": 12,
  "utensils": 8,
  "bucket": 2,
  "mug": 1,
  "cloth stand": 6,
  "iron box": 2,
  "fan": 4,
  "ceiling fan": 5,
  "table fan": 3,
  "cooler": 12,
  "inverter battery": 8,
  "battery": 6,
  "washing stand": 4,
  "dustbin": 2,
  "bed sheet": 1,
  "blanket": 3,
  "quilt": 4,
  "curtains": 2,
  "carpet": 8,
  "plastic container": 2,
  "storage box": 3,
  "tool kit": 3,
  "ladder": 10,
  "water can": 3,
  "water drum": 10,
  "helmet": 2,
  "suitcase": 6,
  "travel bag": 5,
  "file box": 3,
  "documents": 1,
  "decor items": 3,
  "show pieces": 3,
  "temple": 10,
  "washing powder box": 2,
  "cleaning items": 2,

  "air fryer": 4,
  "aquarium small": 8,
  "aquarium large": 15,
  "bar cabinet": 25,
  "bar stool": 3,
  "baby cot": 25,
  "baby wardrobe": 20,
  "bunk bed": 45,
  "buffet table": 40,
  "bicycle adult": 18,
  "bicycle kids": 12,
  "bookcase large": 35,
  "bookshelf tall": 25,
  "blender": 2,
  "bread maker": 3,
  "coffee maker": 3,
  "chest freezer": 35,
  "chest of drawers": 35,
  "console table": 12,
  "corner sofa": 60,
  "cot": 25,
  "credenza": 22,
  "crockery cabinet": 25,
  "crockery rack": 15,
  "dining chair single": 4,
  "dining chairs set 4": 16,
  "dining chairs set 6": 24,
  "display cabinet": 30,
  "dj equipment": 6,
  "drawer chest": 30,
  "drum set": 12,
  "dumbbell rack": 8,
  "elliptical machine": 15,
  "electric kettle": 1,
  "electric scooter": 10,
  "exercise bike": 12,
  "folding bed": 25,
  "foot stool": 3,
  "futon sofa": 40,
  "gaming chair": 8,
  "gaming console": 2,
  "golf bag": 8,
  "grandfather clock": 15,
  "hall stand": 18,
  "home safe small": 8,
  "home safe large": 15,
  "induction cooktop": 3,
  "ironing board": 3,
  "jhula swing": 25,
  "juicer": 2,
  "kids study desk": 12,
  "kitchen island": 35,
  "kitchen trolley": 10,
  "l shaped sofa": 55,
  "lamp floor": 4,
  "lamp table": 3,
  "leather sofa 2 seater": 38,
  "leather sofa 3 seater": 58,
  "loveseat sofa": 28,
  "massage chair": 25,
  "mini fridge": 8,
  "mirror full length": 5,
  "modular wardrobe": 55,
  "monitor 24 inch": 3,
  "monitor 27 inch": 4,
  "music keyboard": 4,
  "ottoman storage": 10,
  "outdoor table": 25,
  "outdoor chairs set": 16,
  "oven built in": 12,
  "packing cartons extra large": 9,
  "patio furniture set": 40,
  "pet carrier large": 6,
  "piano upright": 35,
  "piano digital": 15,
  "ping pong table": 35,
  "plastic stool": 2,
  "pool table": 85,
  "printer scanner combo": 6,
  "projector": 3,
  "puja shelf unit": 12,
  "rice cooker electric": 3,
  "room divider": 8,
  "rowing machine": 18,
  "rug large": 12,
  "rug medium": 8,
  "rug small": 5,
  "sectional sofa large": 70,
  "server rack small": 12,
  "sewing machine portable": 4,
  "sewing table": 15,
  "shoe bench": 8,
  "shoe cabinet large": 15,
  "side board": 22,
  "silverware chest": 4,
  "smart tv 50 inch": 10,
  "smart tv 65 inch": 12,
  "sofa bed": 45,
  "sofa cum bed": 50,
  "soundbar": 2,
  "speaker tower": 8,
  "sports equipment bag": 10,
  "stand fan": 4,
  "steam iron": 2,
  "step ladder": 6,
  "stereo amplifier": 4,
  "study chair": 6,
  "suitcase large": 8,
  "suitcase medium": 6,
  "swing chair indoor": 20,
  "tablet device": 1,
  "tool chest": 10,
  "treadmill": 28,
  "treadmill folding": 25,
  "tumble dryer": 22,
  "tv 24 inch": 4,
  "tv 40 inch": 6,
  "tv 50 inch": 8,
  "tv 55 inch": 9,
  "tv 65 inch": 11,
  "tv wall mount bracket box": 5,
  "vacuum cleaner": 4,
  "wall clock large": 4,
  "wardrobe sliding 2 door": 40,
  "wardrobe sliding 3 door": 55,
  "washing machine front load": 20,
  "washing machine top load": 18,
  "water heater geyser": 6,
  "weights bench": 10,
  "weights set": 8,
  "wine cooler": 15,
  "wine rack": 6,
  "workstation chair ergonomic": 9,
  "yoga mat": 2,

  "misc items": 5
};

export const ITEM_CFT_OPTIONS = Object.keys(ITEM_CFT_MAPPING);

export default ITEM_CFT_MAPPING;
